import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { DesignProvider } from './context/DesignContext';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <DesignProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </DesignProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
